import { createSelector } from 'reselect'

import { selectLandingState } from './selectLandingState'

export const selectLandingSelectedPlanning = createSelector(
  [selectLandingState],
  ({ selectedPlanning }) => selectedPlanning
)
